TradeNews2.vue<template>
	<!-- star -->

	<div class="youjiaopage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
		<!-- 面包屑 -->
<!--		<div class="Crumbs">-->
<!--			<div>当前位置：首页><span>金融</span></div>-->
<!--		</div>-->
		<!--  -->
		<div class="NewsDetails">
			<div class="NewsDetails_cont">
				<div class="NewsDetails_cont_title">
					<h1>《数字新势力：北京数字人才发展大会引领未来》</h1>
					<div class="NewsDetails_cont_title_span">
						<img src="../../assets/img/newsDetail/矩形.png" alt="" /><span
							>发布时间：2024-11-25&ensp;&ensp;
						</span>
<!--						<img src="../../assets/img/newsDetail/矩形(1).png" alt="" /><span-->
<!--							>浏览次数：288-->
<!--						</span>-->
					</div>
				</div>
				<div class="NewsDetails_cont_text">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为深入探讨人工智能与教育的深度融合，推动数字人才发展，11月20日，“AI+教育创新与人才发展大会暨首届北京数字人才发展大会”在海淀区中关村国际创新中心启幕。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/5/01.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人力资源社会保障部领导、北京市领导出席大会并致辞，彰显了政府对数字人才发展的高度重视。中国工程院院士、启元实验室主任廖湘科，清华大学软件学院院长、大数据系统软件国家工程研究中心执行主任王建民作主旨报告等。廖湘科院士以《大模型与通用人工智能：态势与展望》为题，以九格通用基础大模型为例，介绍了启元实验室在大模型研发方面的技术思路和体系，为数字人才的培养和发展提供了前沿的技术视角。王建民院长则分享了有关数字人才培养的实践，为数字人才的教育和成长提供了新的思路和方法。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着数字经济的蓬勃发展，数字人才的需求日益凸显。北京市作为全国科技创新中心，积极响应时代号召，大力推动数字人才的培养与发展，并且充分发挥自身科技和教育资源优势，致力于培养数字技术技能人员。这一举措不仅为本市的数字经济提供了充足的智力支持，也为全国的数字人才队伍建设树立了标杆。在《北京市加快数字人才培育支撑数字经济发展实施方案(2024-2026年)》的指导下，北京市不断优化数字人才培养体系，努力打造具有北京特色的高素质专业人才队伍。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/5/02.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次大会旨在搭建一个高端对话平台，与会者深入交流，共同探讨人工智能技术与教育、数字产业的高度融合与创新实践，为推动教育数字化转型、培养适应未来社会需求的数字人才贡献力量，为北京建设全球数字经济标杆城市提供强有力的人才保障。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;值得一提的是，北京市人社局还发布了首批北京数字人才培育典型案例、北京市数字领域专业技术人员继续教育基地名录和北京市数字技术工程师培训机构名录。这些举措将进一步推动数字人才的培养和发展，为北京市乃至全国的数字经济注入新的活力。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;首批北京数字人才培育典型案例涵盖了头部企业、行业协会、研究机构等不同主体，在人工智能、大数据、网络安全、智慧能源服务等专业领域取得了明显实践成效。这些案例既有首席数据官、数字工程师培育的先进经验，也有数字技术、运营维护以及应用型人才培训的实践探索，为数字人才培育提供了丰富的经验借鉴。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京市数字领域专业技术人员继续教育基地名录包括北京工业大学、中国人民大学、北京城市学院、北京技术市场协会等 34 家单位，培训领域涉及高端装备、新一代信息技术、新能源等。北京市数字技术工程师培训机构名录包括中国机械工程学会、中国电子学会、国家开放大学等 39 家单位，可为大数据、区块链、人工智能等相关职业提供培训。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;这些名录和平台的发布，标志着北京市在数字人才培育方面迈出了坚实的一步，将为数字经济的发展提供强有力的人才支撑。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;同时，大会还举办了多场主题平行分会议，涵盖“AI+产教融合”“AI+组织发展”“AI+新质生产力”等多个热点话题。与会专家和企业代表们从不同角度探讨了数字人才的培养与发展，共同为未来的教育创新出谋划策。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在“AI+产教融合”分论坛上，多位教育界和企业界代表分享了产教融合的成功案例，强调了教育与产业之间的紧密联系。通过校企合作、实习实训等方式，学生们能够更好地适应市场需求，提升自身的职业技能和创新能力。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在“AI+组织发展”分论坛上，专家们探讨了人工智能技术对组织结构和管理的深刻影响。AI技术的应用不仅可以提高工作效率，还可以优化资源配置，推动企业实现数字化转型。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/5/03.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京弘易信泰科技发展有限公司受邀参与此次大会，与各方代表一同深入探讨人工智能技术在各领域的融合以及创新实践。该公司作为一家创新型软件与信息服务企业，致力于应用大数据、人工智能、云计算等技术，为客户提供定制化的数据治理解决方案，助力客户信息化业务发展。通过此次大会，也将进一步强化数字人才培养工作，提升自身数字技术水平和创新能力，为推动数字经济的发展贡献力量。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在数字经济迅猛发展的时代，人才已然成为推动数字经济前行的关键要素。首届北京数字人才发展大会的圆满举办，象征着北京市在数字人才培育领域迈出了坚实有力的一步。</p>

        </div>

<!--				<div class="NewsDetails_cont_btm">-->
<!--					<div>相关新闻</div>-->
<!--					<p>更多 ></p>-->
<!--				</div>-->
<!--				<div class="NewsDetails_cont_btm2">-->
<!--					<div class="NewsDetails_cont_btm2_1">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--					<div class="NewsDetails_cont_btm2_1" style="background: #f8f8f8">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</div>

		<footer2></footer2>

		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../../components/footer.vue";
import banner2 from "../../components/banner.vue";
import nav2 from "../../components/nav.vue";
export default {
	name: "news2",
	components: {
		footer2,
		nav2,
		banner2,
	},
	// data() {
	// 	return {
	// 		h1: "企业新闻",
	// 		Img1: require("../../assets/img/keji/矿山banner1.png"),
  //
	// 		p1: "更多最新精彩资讯，感受企业魅力",
	// 	};
	// },
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
  //font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  text-align: left;
}
/*字体 文本居左*/
ul {
  list-style: none;
}
/*去ul li 小点*/
img {
  border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}
/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
/*清浮动*/
a {
  color: #000000;
}
/*==========================Reset_End===========================*/

.youjiaopage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}
/* 面包屑 */
.Crumbs {
  width: 1200px;
  height: 46px;
  margin: 0 auto;
}
.Crumbs {
  font-size: 12px;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}
/* 新闻详情 */
.NewsDetails_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px ;
  border-top: 1px solid #eaeaea;
}
.NewsDetails_cont_title > h1 {
  font-size: 28px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 800;
  color: #2b2b2b;
  line-height: 33px;
  margin-top: 78px;
  text-align: center;
}
.NewsDetails_cont_title img {
  vertical-align: middle;
}
.NewsDetails_cont_title_span {
  text-align: center;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 30px;
  margin-top: 20px;
}
.NewsDetails_cont_text {
  //margin-top: 40px;
  //border-top: 1px solid #eaeaea;
  font-family: AlibabaPuHuiTi-3-55-Regular;
}
.NewsDetails_cont_text p {
  line-height: 28px;
  width: 1000px;
  margin: 40px 100px;
  font-size: 16px;
  font-weight: lighter;
}
.NewsDetails_cont_text div {
  line-height: 24px;
  margin-left: 90px;
  font-size: 24px;
  font-weight: bold;
}
.NewsDetails_cont_img {
  width: 1000px;
  text-align: center;
  margin-bottom: 40px;
}
.NewsDetails_cont_footer {
  padding: 0 40px;

  line-height: 68px;
  width: 1120px;
  height: 68px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm div {
  font-size: 24px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #222222;
  line-height: 33px;
}
.NewsDetails_cont_btm p {
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.NewsDetails_cont_btm2 {
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm2_1 {
  margin: 32px 0;
  padding: 31px 61px 31px 20px;
  width: 507px;
  height: 123px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
}
.NewsDetails_cont_btm2_1 div {
  font-size: 18px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.NewsDetails_cont_btm2_1 p {
  margin-top: 10px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
</style>
